import { Dialog, DialogContent } from '@mui/material';
import React from 'react';
import './othersModal.css';
import CreateEdit from '../PolicyProduct/RiskFactor/Others/CreateEdit';

function OthersCreateModal({ handleClose, productId, setNewValue }) {
  return (
    <Dialog fullWidth={true} maxWidth={'lg'} open={true} onClose={handleClose}>
      <DialogContent className="modalContainer">
        <CreateEdit
          closeCreateEditForm={handleClose}
          othersEditDatas={null}
          editStatus={false}
          productId={productId}
          setNewValue={setNewValue}
        />
      </DialogContent>
    </Dialog>
  );
}

export default OthersCreateModal;
